import api from "api"

export async function loadHouseholdIncomesIds(store, household_id) {
  const incomes = await api.get(`households/${household_id}/incomes`)
  await store.update(state => {
    state.householdIncomeIds[household_id] = incomes.map(income => income.id)

    incomes.forEach(income => {
      state.incomes[income.id] = income
    })
  })
}

export async function loadIncome(store, income_id) {
  const income = await api.get(`incomes/${income_id}`)
  await store.update(state => {
    state.incomes[income.id] = income
  })
}

export async function addIncome(store, { household_id, ...incomeDetails }) {
  const income = await api.post(
    `households/${household_id}/incomes`,
    undefined,
    incomeDetails
  )
  await store.update(state => {
    if (!state.householdIncomeIds[household_id]) {
      state.householdIncomeIds[household_id] = []
    }
    state.householdIncomeIds[household_id].push(income.id)
    if (income.employer_id) {
      if (!state.householdEmployerIds[household_id]) {
        state.householdEmployerIds[household_id] = []
      }
      if (
        state.householdEmployerIds[household_id].indexOf(income.employer_id) ===
        -1
      ) {
        state.householdEmployerIds[household_id].push(income.employer_id)
      }
    }
    state.incomes[income.id] = income
    delete state.incomeBreakdowns[household_id]
  })
  return income
}

export async function updateIncome(store, { id, ...incomeDetails }) {
  const income = await api.patch(`incomes/${id}`, undefined, incomeDetails)

  await store.update(state => {
    state.incomes[income.id] = income
    delete state.incomeBreakdowns[income.household_id]
  })

  return income
}

export async function deleteIncome(store, { household_id, id }) {
  await api.delete(`incomes/${id}`)
  await store.update(state => {
    state.householdIncomeIds[household_id].splice(
      state.householdIncomeIds[household_id].findIndex(
        incomeId => incomeId === id
      ),
      1
    )
    Object.values(state.benefits)
      .filter(({ income_id }) => income_id === id)
      .forEach(({ id }) => {
        state.householdBenefitIds[household_id].splice(
          state.householdBenefitIds[household_id].findIndex(
            benefitId => benefitId === id
          ),
          1
        )
        delete state.benefits[id]
      })
    delete state.accounts[id]
    delete state.incomeBreakdowns[household_id]
  })
}
